import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconAnomalyDetection = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.orangePeel }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M12.0254 9.28125H15V15H1V9.28125H3.625L5.2959 12.375L7.32617 7.87207L9.35645 12.3662L11.3945 7.87207L12.0254 9.28125ZM15 7.59375H12.8125L11.3945 4.5L9.35645 8.99414L7.32617 4.5L5.2959 8.99414L4.5 7.59375H1V1H15V7.59375Z' fill={color} />
    </svg>;
};

IconAnomalyDetection.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconAnomalyDetection;
